import React, { useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";



const WishListNotification =  () => {

  let {wishListItems}  = useSelector((state) => state.addToWishlist)


            return (
                     <>
                        <div className="wishLisWrapper"
                           
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill={`${wishListItems && wishListItems.length? "red": "green"}`}
                              viewBox="0 0 24 24">
                                <path d="M12 21.328l-1.453-1.313q-2.484-2.25-3.609-3.328t-2.508-2.672-1.898-2.883-0.516-2.648q0-2.297 1.57-3.891t3.914-1.594q2.719 0 4.5 2.109 1.781-2.109 4.5-2.109 2.344 0 3.914 1.594t1.57 3.891q0 1.828-1.219 3.797t-2.648 3.422-4.664 4.359z"/>
                            </svg>
                            <span className="wishlistNotification">
                                { wishListItems && wishListItems? wishListItems.length : 0}
                            </span>                        
                        </div>
                     </>
            )
  }

  export default WishListNotification;
